import message from '@/views/message/message'
import messageDetail from '@/views/message/messageDetail'


export default [
  {
    path: '/message',
    name: 'message',
    component: message,
    meta: {
      title: '消息',
      requireAuth: false,
      requireUserInfo: true
    }
  },
  {
    path: '/messageDetail',
    name: 'messageDetail',
    component: messageDetail,
    meta: {
      title: '消息详情',
      requireAuth: false
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/message.js